export const ROLES = {
  ADMIN: {id: 1, name: 'Admin'},
  MFI_ADMIN: {id: 2, name: 'MFI Admin'},
  QSE_MGR: {id: 3, name: 'QSE Governance Manager'},
  SUPPLY_CHAIN_MGR: {id: 11, name: 'Supply Chain Manager'},
  QSE_SUSTAINABILITY_MGR: {id: 13, name: 'QSE Sustainability Manager'},
  QSE_SAFETY_MANAGER: {id: 15, name: 'QSE Safety Manager'},
  QSE_MEMBER: {id: 16, name: 'QSE Member'},
  BOTTLER_CORP: {id: 19, name: 'Bottler (Corporate)'},
  BOTTLER: {id: 20, name: 'Bottler (Facility)'},
  IM_MANAGER: {id: 24, name: 'IM Manager'},
  IM_VIEWER: {id: 25, name: 'IM Viewer'},
  BOTTLER_SUPPLY_CHAIN: {id: 30, name: 'Bottler (Supply Chain)'}
}